import Icon from '@ant-design/icons';

function CompetitorsSvg() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3559_265)">
        <path
          d="M8.06699 5.40738C8.54197 5.9085 9.25683 6.23624 10.0263 6.23624H10.1569C10.8005 6.23624 11.5107 5.94412 11.8669 5.54513C11.9144 5.49288 12.5818 6.25286 13.9426 6.23624H14.0732C14.7311 6.23624 15.2844 6.00825 15.5861 5.60688C15.8877 5.20551 15.9162 4.5524 15.6478 4.14866L14.249 1.60035C14.2395 1.58135 14.2276 1.5671 14.2157 1.55285C14.135 1.41985 13.9473 1.32011 13.793 1.32961H8.13111M11.8645 5.54276L11.0333 1.4056"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          d="M8.40661 1.3272H2.4835C2.3315 1.3177 2.14151 1.41745 2.06076 1.55045C2.04888 1.56707 2.03701 1.58132 2.02751 1.59795L0.628667 4.14626C0.360298 4.55 0.388797 5.20311 0.690415 5.60448C0.992033 6.00584 1.54302 6.23384 2.20325 6.23384H2.33388C3.69472 6.25046 4.36208 5.49048 4.40958 5.54273C4.76344 5.94172 5.47355 6.23384 6.11954 6.23384H6.25016C7.01964 6.23384 7.73213 5.90847 8.20949 5.40498M5.23843 1.40558L4.4072 5.54273M8.13349 1.11108V5.63773"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          d="M1.80426 6.25037V14.1993C1.80426 14.7622 2.22463 15.2229 2.73999 15.2229H13.5127C14.0281 15.2229 14.4485 14.7622 14.4485 14.1993V6.25037"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          d="M14.6052 12.0098H1.50739"
          stroke="currentColor"
          strokeWidth={1.5}
        />
      </g>
      <defs>
        <clipPath id="clip0_3559_265">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function CompetitorsIcon() {
  return <Icon component={CompetitorsSvg} />;
}

function HouseholdsSvg() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3559_313)">
        <path
          d="M6.2689 14.8489V9.97115C6.2689 9.71337 6.47779 9.50226 6.73334 9.50226H9.15334C9.4089 9.50226 9.61779 9.71337 9.61779 9.97115V14.8489M14.8667 5.81559L8.56001 1.16004C8.18446 0.88448 7.70223 0.88448 7.3289 1.16004L1.02001 5.81559C0.7689 6.00226 0.6689 6.31337 0.764455 6.61115C0.862233 6.91115 1.12446 7.10448 1.43779 7.10448H2.0289V13.9467C2.0289 14.4311 2.42223 14.8289 2.90446 14.8289H12.9845C13.4667 14.8289 13.86 14.4334 13.86 13.9467V7.10448H14.4511C14.7622 7.10448 15.0267 6.91115 15.1245 6.61115C15.22 6.31337 15.1222 6.00004 14.8711 5.81559H14.8667Z"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          d="M14.0333 7.10449H1.5889"
          stroke="currentColor"
          strokeWidth={1.5}
        />
      </g>
      <defs>
        <clipPath id="clip0_3559_313">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function HouseholdsIcon() {
  return <Icon component={HouseholdsSvg} />;
}

function IncomeSvg() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.30931 8.57354L1.5027 7.94871L1.50311 8.96902L1.50326 9.33515C1.50326 9.33517 1.50326 9.33519 1.50326 9.33521C1.50326 9.33525 1.50326 9.3353 1.50326 9.33535C1.50332 9.8249 1.7538 10.2659 2.10002 10.6272C2.44995 10.9923 2.93594 11.3183 3.50943 11.5907C4.65858 12.1364 6.23339 12.5018 8.00327 12.5018C9.73656 12.5018 11.2823 12.1514 12.4243 11.6248C12.9945 11.3618 13.4805 11.0474 13.8387 10.6958C14.1925 10.3485 14.4581 9.92762 14.4981 9.45614L14.499 9.44557L14.4995 9.43497L14.5028 9.35631L14.5032 9.34628L14.5033 9.33624L14.5041 8.96938L14.5063 7.94656L13.6978 8.57306C12.4832 9.51428 10.4092 10.1685 8.00327 10.1685C5.59778 10.1685 3.52405 9.51454 2.30931 8.57354ZM8.00327 3.16852C9.96113 3.16852 11.7089 3.60246 12.9493 4.27903C14.2086 4.96593 14.8366 5.83268 14.8366 6.66848V9.33515C14.8366 10.171 14.2086 11.0378 12.9493 11.7247C11.7089 12.4012 9.96113 12.8352 8.00327 12.8352C6.0807 12.8352 4.36015 12.4167 3.1238 11.7605C1.87169 11.0959 1.21919 10.2513 1.17269 9.43284L1.16992 9.32853V6.66848C1.16992 5.83268 1.79792 4.96593 3.05723 4.27903C4.29764 3.60246 6.04539 3.16852 8.00327 3.16852ZM8.00327 3.50185C6.23339 3.50185 4.65858 3.86726 3.50943 4.41297C2.93594 4.68531 2.44995 5.01138 2.10002 5.3765C1.75376 5.73779 1.50326 6.17886 1.50326 6.66848C1.50326 7.15812 1.75375 7.59919 2.10002 7.96048C2.44995 8.32561 2.93594 8.65168 3.50943 8.92403C4.65858 9.46974 6.23339 9.83515 8.00327 9.83515C9.77315 9.83515 11.348 9.46974 12.4971 8.92403C13.0706 8.65168 13.5566 8.3256 13.9065 7.96048C14.2528 7.59919 14.5033 7.15812 14.5033 6.66848C14.5033 6.17886 14.2528 5.73779 13.9065 5.3765C13.5566 5.01138 13.0706 4.68531 12.4971 4.41297C11.348 3.86726 9.77315 3.50185 8.00327 3.50185Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
}
export function IncomeIcon() {
  return <Icon component={IncomeSvg} />;
}

function ParkingSvg() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x={2.08334}
        y={2.08337}
        width={11.8333}
        height={11.8333}
        rx={1.25}
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path
        d="M6.00284 11.3333V4.54541H8.54829C9.06976 4.54541 9.50726 4.64263 9.86079 4.83708C10.2165 5.03152 10.485 5.29888 10.6662 5.63916C10.8496 5.97723 10.9413 6.3617 10.9413 6.79257C10.9413 7.22786 10.8496 7.61454 10.6662 7.95261C10.4828 8.29068 10.2121 8.55693 9.85416 8.75138C9.49621 8.94361 9.0554 9.03973 8.53172 9.03973H6.84469V8.02884H8.366C8.67093 8.02884 8.92061 7.97581 9.11505 7.86975C9.3095 7.76369 9.45312 7.61785 9.54593 7.43225C9.64094 7.24664 9.68844 7.03342 9.68844 6.79257C9.68844 6.55172 9.64094 6.3396 9.54593 6.15621C9.45312 5.97281 9.30839 5.83029 9.11174 5.72865C8.9173 5.6248 8.66651 5.57287 8.35937 5.57287H7.23248V11.3333H6.00284Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function ParkingIcon() {
  return <Icon component={ParkingSvg} />;
}

function PedestrianSvg() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3559_320)">
        <path
          d="M9.33332 2.66671C9.33332 3.40309 8.73637 4.00004 7.99999 4.00004C7.26361 4.00004 6.66666 3.40309 6.66666 2.66671C6.66666 1.93033 7.26361 1.33337 7.99999 1.33337C8.73637 1.33337 9.33332 1.93033 9.33332 2.66671Z"
          stroke="currentColor"
          strokeWidth={1.5}
        />
        <path
          d="M4.03187 7.23283L4.26904 6.52132L4.26904 6.52132L4.03187 7.23283ZM5.48207 7.71623L5.2449 8.42774L5.2449 8.42774L5.48207 7.71623ZM6.01122 8.8375L5.31121 8.56827L5.31121 8.56827L6.01122 8.8375ZM5.18003 10.9986L5.88004 11.2678L5.88004 11.2678L5.18003 10.9986ZM11.9681 7.23283L11.731 6.52132L11.731 6.52132L11.9681 7.23283ZM10.518 7.71623L10.7551 8.42774L10.7551 8.42774L10.518 7.71623ZM9.9888 8.8375L10.6888 8.56827L10.6888 8.56827L9.9888 8.8375ZM10.82 10.9986L10.12 11.2678L10.12 11.2678L10.82 10.9986ZM6.94946 11.8385L7.60064 12.2106L7.60064 12.2106L6.94946 11.8385ZM8.00001 9.99999L8.65119 9.62788C8.51766 9.3942 8.26915 9.24999 8.00001 9.24999C7.73087 9.24999 7.48236 9.3942 7.34883 9.62788L8.00001 9.99999ZM11.431 5.26477L11.2739 4.53141L11.2739 4.53141L11.431 5.26477ZM10.166 5.53585L10.3231 6.2692L10.3231 6.2692L10.166 5.53585ZM5.83402 5.53585L5.99117 4.8025L5.99117 4.8025L5.83402 5.53585ZM4.56898 5.26477L4.41183 5.99812L4.56898 5.26477ZM9.05056 11.8385L8.39938 12.2106L8.39938 12.2106L9.05056 11.8385ZM10.0256 5.56567L9.87369 4.83122L9.87369 4.83122L10.0256 5.56567ZM5.97441 5.56567L5.82249 6.30012L5.82249 6.30012L5.97441 5.56567ZM10.1892 7.84453L10.5831 8.48274L10.5831 8.48274L10.1892 7.84453ZM9.87883 8.50214L10.6219 8.40054L10.6219 8.40053L9.87883 8.50214ZM5.81084 7.84453L5.4169 8.48274L5.4169 8.48274L5.81084 7.84453ZM6.12119 8.50214L6.86427 8.60376L6.86427 8.60375L6.12119 8.50214ZM3.7947 7.94434L5.2449 8.42774L5.71924 7.00472L4.26904 6.52132L3.7947 7.94434ZM5.31121 8.56827L4.48002 10.7294L5.88004 11.2678L6.71123 9.10673L5.31121 8.56827ZM11.731 6.52132L10.2808 7.00472L10.7551 8.42774L12.2053 7.94434L11.731 6.52132ZM9.28879 9.10673L10.12 11.2678L11.52 10.7294L10.6888 8.56827L9.28879 9.10673ZM7.60064 12.2106L8.65119 10.3721L7.34883 9.62788L6.29828 11.4663L7.60064 12.2106ZM11.2739 4.53141L10.0089 4.8025L10.3231 6.2692L11.5882 5.99812L11.2739 4.53141ZM5.99117 4.8025L4.72613 4.53141L4.41183 5.99812L5.67688 6.2692L5.99117 4.8025ZM7.34883 10.3721L8.39938 12.2106L9.70175 11.4664L8.65119 9.62788L7.34883 10.3721ZM10.0089 4.8025C9.93751 4.81778 9.90535 4.82467 9.87369 4.83122L10.1775 6.30012C10.2156 6.29225 10.2538 6.28406 10.3231 6.2692L10.0089 4.8025ZM5.67688 6.2692C5.74623 6.28406 5.78441 6.29225 5.82249 6.30012L6.12633 4.83122C6.09467 4.82467 6.06251 4.81778 5.99117 4.8025L5.67688 6.2692ZM9.87369 4.83122C8.63765 5.08689 7.36237 5.08689 6.12633 4.83122L5.82249 6.30012C7.25897 6.59726 8.74105 6.59726 10.1775 6.30012L9.87369 4.83122ZM6.09671 13.0833C6.71831 13.0833 7.29224 12.7503 7.60064 12.2106L6.29828 11.4663C6.25694 11.5387 6.18002 11.5833 6.09671 11.5833V13.0833ZM10.12 11.2678C10.1785 11.4199 10.0662 11.5833 9.90331 11.5833V13.0833C11.1189 13.0833 11.9564 11.8639 11.52 10.7294L10.12 11.2678ZM10.2808 7.00472C10.1465 7.04948 9.95406 7.10828 9.79523 7.20633L10.5831 8.48274C10.5578 8.49837 10.546 8.50057 10.5779 8.48852C10.6127 8.47536 10.6618 8.45883 10.7551 8.42774L10.2808 7.00472ZM10.6888 8.56827C10.6535 8.47649 10.635 8.42806 10.6231 8.39282C10.6121 8.36057 10.6179 8.37105 10.6219 8.40054L9.13575 8.60375C9.16103 8.78869 9.23797 8.9746 9.28879 9.10673L10.6888 8.56827ZM9.79523 7.20633C9.31835 7.50069 9.05982 8.04851 9.13575 8.60375L10.6219 8.40053C10.6264 8.4332 10.6112 8.46542 10.5831 8.48274L9.79523 7.20633ZM11.9167 6.26367C11.9167 6.38057 11.8419 6.48435 11.731 6.52132L12.2053 7.94434C12.9287 7.70321 13.4167 7.02622 13.4167 6.26367H11.9167ZM4.48002 10.7294C4.04365 11.8639 4.88113 13.0833 6.09671 13.0833V11.5833C5.9338 11.5833 5.82156 11.4199 5.88004 11.2678L4.48002 10.7294ZM5.2449 8.42774C5.33818 8.45883 5.38731 8.47536 5.42212 8.48852C5.45397 8.50057 5.44222 8.49837 5.4169 8.48274L6.20479 7.20633C6.04596 7.10828 5.85354 7.04948 5.71924 7.00472L5.2449 8.42774ZM6.71123 9.10673C6.76205 8.9746 6.83899 8.78869 6.86427 8.60376L5.3781 8.40053C5.38214 8.37105 5.3879 8.36057 5.37695 8.39282C5.36499 8.42806 5.34651 8.47649 5.31121 8.56827L6.71123 9.10673ZM5.4169 8.48274C5.38884 8.46542 5.37364 8.4332 5.3781 8.40053L6.86427 8.60375C6.9402 8.04851 6.68167 7.50069 6.20479 7.20633L5.4169 8.48274ZM2.58334 6.26367C2.58334 7.02622 3.07129 7.70321 3.7947 7.94434L4.26904 6.52132C4.15815 6.48435 4.08334 6.38057 4.08334 6.26367H2.58334ZM4.08334 6.26367C4.08334 6.09077 4.24277 5.96189 4.41183 5.99812L4.72613 4.53141C3.62329 4.29509 2.58334 5.1358 2.58334 6.26367H4.08334ZM8.39938 12.2106C8.70778 12.7503 9.28171 13.0833 9.90331 13.0833V11.5833C9.82 11.5833 9.74308 11.5387 9.70174 11.4663L8.39938 12.2106ZM13.4167 6.26367C13.4167 5.1358 12.3767 4.29509 11.2739 4.53141L11.5882 5.99812C11.7573 5.96189 11.9167 6.09077 11.9167 6.26367H13.4167Z"
          fill="currentColor"
        />
        <path
          d="M12.9691 9.66663C14.0248 10.1974 14.6667 10.8983 14.6667 11.6666C14.6667 13.3235 11.6819 14.6666 8.00001 14.6666C4.31811 14.6666 1.33334 13.3235 1.33334 11.6666C1.33334 10.8983 1.97524 10.1974 3.03088 9.66663"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3559_320">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function PedestrianIcon() {
  return <Icon component={PedestrianSvg} />;
}

function PopulationSvg() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 14C14.6667 12.2632 13.6401 10.7464 12.1209 9.9437C11.3908 9.55712 10.5507 9.33331 9.65171 9.33331H6.34635C5.44935 9.33331 4.60534 9.55712 3.87714 9.9437C2.35989 10.7464 1.33334 12.2613 1.33334 14H14.6667Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.66667 2C9.68736 2 11.3333 3.64396 11.3333 5.66667C11.3333 7.68938 9.68938 9.33333 7.66667 9.33333C5.64396 9.33333 4 7.68938 4 5.66667C4 3.64396 5.64396 2 7.66667 2Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeMiterlimit={10}
      />
    </svg>
  );
}
export function PopulationIcon() {
  return <Icon component={PopulationSvg} />;
}

function TjLvlAvgSvg() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 7.33337H2.69699M2.69699 7.33337H13.303M2.69699 7.33337C2.70441 7.29906 2.71318 7.26505 2.72331 7.23145C2.74748 7.15126 2.78162 7.07414 2.85026 6.91969L3.8811 4.6003C4.08491 4.14173 4.18699 3.91231 4.34807 3.74418C4.49045 3.59557 4.66509 3.48204 4.85872 3.41229C5.07778 3.33337 5.3289 3.33337 5.83073 3.33337H10.169C10.6709 3.33337 10.9222 3.33337 11.1413 3.41229C11.3349 3.48204 11.5093 3.59557 11.6517 3.74418C11.8127 3.91219 11.9145 4.14143 12.1181 4.59938L13.1531 6.92813C13.2192 7.07698 13.2529 7.15273 13.2766 7.23145C13.2868 7.26505 13.2956 7.29906 13.303 7.33337M2.69699 7.33337C2.68868 7.3718 2.68207 7.41059 2.67715 7.44959C2.66667 7.53268 2.66667 7.61716 2.66667 7.78617V11.3334M13.303 7.33337H14M13.303 7.33337C13.3114 7.3718 13.318 7.41059 13.3229 7.44959C13.3333 7.53218 13.3333 7.61616 13.3333 7.78313V11.3334M13.3333 11.3334L10.6667 11.3334M13.3333 11.3334V12C13.3333 12.7363 12.7364 13.3334 12 13.3334C11.2636 13.3334 10.6667 12.7364 10.6667 12V11.3334M10.6667 11.3334L5.33333 11.3334M5.33333 11.3334H2.66667M5.33333 11.3334V12C5.33333 12.7364 4.73638 13.3334 4 13.3334C3.26362 13.3334 2.66667 12.7364 2.66667 12V11.3334"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function TjLvlAvgIcon() {
  return <Icon component={TjLvlAvgSvg} />;
}
